/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function($, Drupal) {
  /**
   * @type {{attach: Drupal.behaviors.album.attach}}
   */
  Drupal.behaviors.album = {
    attach : function(context, settings) {
      var locale = settings.pppTheme.global.locale;
      var i18n = {
        en: {
          restart : 'Restart',
          rewind : 'Rewind {seektime} secs',
          play : 'Play',
          pause : 'Pause',
          fastForward : 'Forward {seektime} secs',
          seek : 'Seek',
          played : 'Played',
          buffered : 'Buffered',
          currentTime : 'Current time',
          duration : 'Duration',
          volume : 'Volume',
          mute : 'Mute',
          unmute : 'Unmute',
          enableCaptions : 'Enable captions',
          disableCaptions : 'Disable captions',
          enterFullscreen : 'Enter fullscreen',
          exitFullscreen : 'Exit fullscreen',
          frameTitle : 'Player for {title}',
          captions : 'Captions',
          settings : 'Settings',
          speed : 'Speed',
          normal : 'Normal',
          quality : 'Quality',
          loop : 'Loop',
          start : 'Start',
          end : 'End',
          all : 'All',
          reset : 'Reset',
          disabled : 'Disabled',
          advertisement : 'Ad'
        },
        fr: {
          restart: 'Relancer',
          rewind: 'Reculer de {seektime} secs',
          play: 'Lire',
          pause: 'Pause',
          fastForward: 'Avancer de {seektime} secs',
          seek: 'Rechercher',
          played: 'Joué',
          buffered: 'Tamponnée',
          currentTime: 'Temps actuel',
          duration: 'Durée',
          volume: 'Volume',
          mute: 'Désactiver le son',
          unmute: 'Activer le son',
          enableCaptions: 'Activer les sous-titres',
          disableCaptions: 'Désactiver les sous-titres',
          enterFullscreen: 'Entrer en plein écran',
          exitFullscreen: 'Sortir du plein écran',
          frameTitle: 'Lecteur pour {title}',
          captions: 'Sous-titres',
          settings: 'Paramètres',
          speed: 'Vitesse',
          normal: 'Normal',
          quality: 'Qualité',
          loop: 'Bouble',
          start: 'Début',
          end: 'Fin',
          all: 'Tout',
          reset: 'Réinitialiser',
          disabled: 'Désactivé',
          advertisement: 'Publicité'
        },
        'zh-hans': {
          restart: '重新启动',
          rewind: '倒带 {seektime} 秒',
          play: '玩',
          pause: '暂停',
          fastForward: '前进 {seektime} 秒',
          seek: '寻找',
          played: '玩过',
          buffered: '缓冲',
          currentTime: '当前时间',
          duration: '持续时间',
          volume: '音量',
          mute: '静音',
          unmute: '取消静音',
          enableCaptions: '启用字幕',
          disableCaptions: '禁用字幕',
          enterFullscreen: '输入全屏',
          exitFullscreen: '退出全屏',
          frameTitle: '玩家为 {title}',
          captions: '字幕',
          settings: '设置',
          speed: '速度',
          normal: '正常',
          quality: '质量保证',
          loop: '循环',
          start: '开始',
          end: '结束',
          all: '全部',
          reset: '重置',
          disabled: '残疾人',
          advertisement: '广告'
        }
      };

      window.albumPlyrInterface = {
        player : undefined,
        playerUUID : undefined,
        playerName : undefined,
        playerPlaying : false,
        changingTrack : true,
        selectedTrack : undefined,
        tracks : undefined,

        init : function() {
          this.tracks = $('.album-playlist-item');
          this.player = new Plyr('.audio-plyr-wrapper #player', {
            i18n: i18n[locale],
            controls : $('.audio-plyr-wrapper .plyr__controls').get(0),
            loadSprite : false,
            blankVideo : '/themes/custom/ppp_theme/packages/plyr/blank.mp4'
          });
          this.selectedTrack = this.tracks.first();
          this.updateData();
          this.player.autoplay = true;
          this.addEvents();
        },

        addEvents : function() {
          this.player.on('playing', function() {
            this.playerPlaying = true;
            this.updateData();
            $('.audio-plyr-wrapper .plyr__play').addClass('plyr__control--pressed');
          }.bind(this));

          this.player.on('pause', function() {
            this.playerPlaying = false;
            this.updateData();
            $('.audio-plyr-wrapper .plyr__play').removeClass('plyr__control--pressed');
          }.bind(this));

          this.tracks.click(function() {
            if ($(this).hasClass('selected')) {
              if (window.albumPlyrInterface.playerPlaying) {
                window.albumPlyrInterface.player.pause();
              } else {
                window.albumPlyrInterface.player.play();
              }
            } else {
              window.albumPlyrInterface.selectedTrack = $(this);
              window.albumPlyrInterface.changingTrack = true;
              window.albumPlyrInterface.updateData();
            }
          });
        },

        addEventPlayerControls : function() {
          $('.audio-plyr-wrapper .plyr__previous').click(function() {
            this.selectedTrack = $(this.tracks.get(this.tracks.index(this.selectedTrack) - 1));
            this.changingTrack = true;
            this.updateData();
          }.bind(this));

          $('.audio-plyr-wrapper .plyr__next').click(function() {
            var nextTrack = $(this.tracks.get(this.tracks.index(this.selectedTrack) + 1));
            if (nextTrack.length) {
              this.selectedTrack = nextTrack;
            } else {
              this.selectedTrack = this.tracks.first();
            }
            this.changingTrack = true;
            this.updateData();
          }.bind(this));

          $('.audio-plyr-wrapper .plyr__play').click(function() {
            if (this.playerPlaying) {
              this.player.pause();
            } else {
              this.player.play();
            }
          }.bind(this));
        },

        updateData : function() {
          this.updateSelectedTrackDisplay();
          if (this.changingTrack) {
            this.updatePlayer();
            this.changingTrack = false;
          }
        },

        updateSelectedTrackDisplay : function() {
          if (this.changingTrack) {
            this.tracks.removeClass('selected paused');
            this.selectedTrack.addClass('selected');
          }
          if (this.playerPlaying) {
            this.selectedTrack.removeClass('paused');
          } else {
            this.selectedTrack.addClass('paused');
          }
        },

        updatePlayer : function() {
          $('.audio-plyr-wrapper .plyr__title').html(this.selectedTrack.data('name'));
          this.player.source = {
            type : 'audio',
            sources : [
              {
                src : this.selectedTrack.data('url'),
                type : 'audio/' + this.selectedTrack.data('extension')
              }
            ]
          };
          this.playerUUID = Math.random().toString(36).substr(2, 9);
          this.playerName = this.selectedTrack.data('name');
          this.addEventPlayerControls();
        },
      };

      $(document).ready(function(){
        $(once('plyrAudioBehavior', '.audio-plyr-wrapper')).each(function() {
          window.albumPlyrInterface.init();
        });
      });
    }
  };
})(jQuery, Drupal);
